import uniqid from 'uniqid';

function addTransactionIdHeader(data: any, headers: any) {
  headers['X-Transaction-ID'] = uniqid();
  return data;
}

export default addTransactionIdHeader;
